import { GetterTree } from "vuex";
import { RootState } from "../types";
import { DistanceConfigurationState } from "./types";

export const getters: GetterTree<DistanceConfigurationState, RootState> = {
};
